import React from 'react';
import PropTypes from 'prop-types';
import Form from '../../../components/user/location/locationForm';
import Layout from '../../../components/layouts/verticalLayout';
import { useParams } from 'react-router-dom';

const LocationFormPage = () => {
  let { uuid } = useParams();
  return <Layout body={<Form uuid={uuid} />} />;
};

LocationFormPage.propTypes = {};

export default LocationFormPage;
